import { createContext } from 'react';
export var InstantSearchSSRContext = /*#__PURE__*/createContext(null);

if (process.env.NODE_ENV !== 'production') {
  InstantSearchSSRContext.displayName = 'InstantSearchSSR';
}